import { hstcKey } from '../storageKeys';
import * as cookieHelper from '../client/cookieHelper';
export function getHstc() {
  return cookieHelper.get(hstcKey) || null;
}
export function getUtk() {
  const hstc = getHstc();
  const utk = cookieHelper.get('hubspotutk');
  return utk || hstc && hstc.split('.')[1] || null;
}